module.exports = __webpack_public_path__ + "img/AUTO_HOSPITALISATION_ACTIVE.5673534e.svg";